import TopBar from '@/pages/home/components/TopBar';
import MastheadNav from '@/pages/home/components/MastheadNav';
import CoverHero from '@/pages/home/components/CoverHero';
import IdentityZones from '@/pages/home/components/IdentityZones';
import FlashTimeline from '@/pages/home/components/FlashTimeline';
import CoverFeature from '@/pages/home/components/CoverFeature';
import HeatRanking from '@/pages/home/components/HeatRanking';
import DossierGrid from '@/pages/home/components/DossierGrid';
import EditorNotes from '@/pages/home/components/EditorNotes';
import TopicEntrances from '@/pages/home/components/TopicEntrances';
import SubscribeBlock from '@/pages/home/components/SubscribeBlock';
import SiteFooter from '@/pages/home/components/SiteFooter';
import BackToTop from '@/pages/home/components/BackToTop';
import Reveal from '@/pages/home/components/Reveal';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <TopBar />
      <MastheadNav />

      <main>
        <CoverHero />
        <Reveal>
          <IdentityZones />
        </Reveal>
        <Reveal>
          <FlashTimeline />
        </Reveal>
        <Reveal>
          <CoverFeature />
        </Reveal>
        <Reveal>
          <HeatRanking />
        </Reveal>
        <Reveal>
          <DossierGrid />
        </Reveal>
        <Reveal>
          <EditorNotes />
        </Reveal>
        <Reveal>
          <TopicEntrances />
        </Reveal>
        <Reveal>
          <SubscribeBlock />
        </Reveal>
      </main>

      <SiteFooter />
      <BackToTop />
    </div>
  );
}